import urlConfig from "@adapters/infrastructures/urlConfig/homeUrl";
class AdvDecRequestMapper {
    formatRequest(syms, reqType, subscribe) {
        const symbols = syms.map((x) => {
            return { symbol: x };
        });
        const subReq = {
            request: {
                streaming_type: reqType,
                data: { symbols },
                formFactor: "W",
                response_format: "json",
                request_type: subscribe ? "subscribe" : "unsubscribe",
                appID: urlConfig.appid,
            },
            echo: {},
        };
        return JSON.stringify(subReq);
    }
}
export default AdvDecRequestMapper;
